export default __webpack_public_path__ + "assets/multiple-devices.474d2214.svg";